module.exports = __webpack_public_path__ + "img/price-2.a02925a2.png";